// Version service for fetching app version information
import axios from '../utils/axios';

export const versionService = {
  // Get simple version string
  async getVersion() {
    try {
      const response = await axios.get('/version/simple');
      return response.data.version;
    } catch (error) {
      console.error('Error fetching version:', error);
      // Fallback to buildInfo if API fails
      const { getVersionString } = await import('../utils/buildInfo');
      return getVersionString();
    }
  },

  // Get full version information
  async getVersionInfo() {
    try {
      const response = await axios.get('/version/info');
      return response.data;
    } catch (error) {
      console.error('Error fetching version info:', error);
      // Fallback to buildInfo if API fails
      const { getBuildInfo } = await import('../utils/buildInfo');
      return getBuildInfo();
    }
  }
};

export default versionService;